<template>
  <section class="mb-10 text-center">
    <h2 class="mt-5">
      {{
        $store.state.data.Steps[$store.state.activeStep].Title.replace(
          "${name}",
          $store.state.userInputs.FirstName__c
        )
      }}
    </h2>
    <div
      class="text-editor text-base md:text-xl"
      v-html="
        $store.state.data.Steps[$store.state.activeStep]
          .ThankYouMessageBeforeImage
      "
    ></div>
    <div class="rounded-full flex items-center justify-center mx-auto my-4">
      <img
        :src="$store.state.data.Steps[$store.state.activeStep].ThankYouImageUrl"
        class="flex-shrink-0 max-h-full max-w-full"
      />
    </div>
    <div
      class="mb-5 text-base md:text-xl"
      v-html="
        $store.state.data.Steps[
          $store.state.activeStep
        ].ThankYouMessageAfterImage.replace(
          '${emailAddress}',
          '\n <div></div><strong>' +
            $store.state.userInputs.Email__c +
            '</strong>'
        )
      "
    ></div>
    <p>
      <a
        class="inline-block text-lg md:text-xl text-velux-blue underline hover:no-underline"
        :href="$store.state.data.Steps[$store.state.activeStep].ButtonLinkUrl"
        @click="trackGoHome()"
      >
        {{ $store.state.data.Steps[$store.state.activeStep].ButtonLinkText }}
      </a>
    </p>
  </section>
</template>

<script>
import tracking from "../../mixins/tracking.js";
import { mapGetters } from "vuex";

export default {
  props: {
    imgSrc: String
  },
  methods: {
    trackGoHome: function () {
      tracking({
        eventAction: "go to marketing home page"
      });
    }
  },
  computed: {
    ...mapGetters([
      "getActiveStepId"
    ]),
    emailAddress: function () {
      return this.$store.state.data.Steps[this.getActiveStepId].ThankYouMessageAfterImage.replace(
        "${emailAddress}",
        this.$store.state.userInputs.Email__c
      );
    }
  }
};
</script>
